import { render, staticRenderFns } from "./VisualizarDocumento.vue?vue&type=template&id=7a13743c"
import script from "./VisualizarDocumento.vue?vue&type=script&lang=js"
export * from "./VisualizarDocumento.vue?vue&type=script&lang=js"
import style0 from "./VisualizarDocumento.vue?vue&type=style&index=0&id=7a13743c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports